import { Space, Table } from 'antd';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { EditActionSvg } from 'utils/svgs';
import { checkPermission } from 'utils/utils';
import SearchAndFilter from '../SearchAndFilter';
import styles from './index.module.scss';
import { CustomTableProps } from './type';

const CustomTable: FC<CustomTableProps> = (props) => {
	const {
		Column } = Table;
	const {
		dataSource,
		isLoading,
		search,
		performSearchHandler,
		openDrawerHandler,
		setDrawerInfoHandler,
		setEditSelectedCategory,
		isSearchCancel,
		setSearch,
		setIsSearchCancel,
	} = props;

	const userPermissions = useSelector(
		(state: any) => state?.userProfile?.data?.permissions
	);
	const isEditPermission = checkPermission(userPermissions, {
		permissionName: 'CategoryDoseFormMapping',
		permission: ['edit'],
	});

	const editDataHandler = (row: { id: string; categoryName: string; doseForms: { id: string; name: string }[] }) => {
		openDrawerHandler();
		setDrawerInfoHandler(`Edit - ${row.categoryName}`);
		setEditSelectedCategory(row);
	};

	return (
		<div className={`${styles.body} user-table-pagination`}>
			<SearchAndFilter
				performSearchHandler={performSearchHandler}
				searchValue={search}
				title="Category Dose Form Mapping List"
				isSearchCancel={isSearchCancel}
				setSearch={setSearch}
				setIsSearchCancel={setIsSearchCancel}
			/>

			<Table
				rowKey={(record) => record.id}
				dataSource={dataSource}
				pagination={false}
				loading={isLoading}
				scroll={{ y: 'calc(100vh - 300px)' }}
			>
				<Column
					title="Category"
					dataIndex="categoryName"
					key="categoryName"
					className="user-column bg-white"
					width="25%"
				/>
				<Column
					title="Mapped Dose Forms"
					dataIndex="doseForms"
					key="doseForms"
					className="bg-white"
					width="50%"
					render={(doseForms: { id: string; name: string }[]) =>
						doseForms?.length
							? doseForms.map((d) => d.name).join(', ')
							: '—'
					}
				/>
				{isEditPermission && (
					<Column
						title="Action"
						key="action"
						className="bg-white"
						width="15%"
						render={(_, record: { id: string; categoryName: string; doseForms: { id: string; name: string }[] }) => (
							<Space size={20}>
								<div
									className="cursor-pointer flex align-center justify-center rounded-action-btn"
									onClick={() => editDataHandler(record)}
								>
									<EditActionSvg />
								</div>
							</Space>
						)}
					/>
				)}
			</Table>
		</div>
	);
};

export default CustomTable;
